import { setIdentityClock, setIdentityCommitPredicate, storeManager } from '@pressreader/appstore';
import { svcAuth } from '@pressreader/services';

import { AUTHENTICATION_CORE_MODULE_NAME } from '../constants';

import { identityCommitPredicate } from './identity.commit';
import { reducer } from './reducer';
import { saga } from './sagas';

storeManager.addFeature(AUTHENTICATION_CORE_MODULE_NAME, reducer, saga);

// The RTK Query identity fence reads the token clock through an injected seam: appstore cannot import
// `@pressreader/services` itself (appstore -> services -> config -> appstore is a project cycle), and this
// module — which may import both — is the auth bootstrap every consumer of the auth slice goes through.
// Wired at module scope so the clock is in place before any feature can dispatch a query; left unwired the
// fence fails open (see `setIdentityClock`), which is a silent loss of protection, not a visible failure.
setIdentityClock({
    key: () => svcAuth.identityKey(),
    generation: () => svcAuth.identityGeneration(),
    // Read off the `svcAuth` namespace rather than a named barrel export, so `@pressreader/services`' public
    // surface (and its CRLF barrel file) is left exactly as it was.
    anonymousKey: svcAuth.ANONYMOUS_IDENTITY_KEY,
});

// The identity COMMIT predicate is the same injected-seam pattern as the clock above: appstore cannot import this
// lib either (recognizing a commit means reading the auth slice), so auth-core hands it the recognizer. The
// listener it drives is armed lazily inside appstore (`declareIdentityPolicy` -> `armIdentityCommitReconcile`), so
// this line adds nothing to the eager path but the predicate closure itself.
setIdentityCommitPredicate(identityCommitPredicate);

export * from './actions';
export * from './selectors';
